import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';

export const EditAddOnCategoryForm = (strings: any, id: number): FormModel[] => {
  return [
    {
      label: strings.add_on_category_code,
      value: '',
      autoFocus: true,
      type: 'text',
      placeholder: '',
      field: 'code',
      validators: [],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      disabled: !!id,
    },
    {
      label: strings.add_on_category_service_charge,
      value: false,
      type: 'checkbox',
      field: 'serviceChargeApplicable',
      responsive: { xs: 12, sm: 6, md: 4 },
      placeholder: '',
      validators: [],
      required: false,
    },
    {
      label: null,
      value: null,
      type: 'divider',
      placeholder: '',
      field: null,
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
    {
      label: strings.add_on_category_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
  ];
};
